import {
  resetAuctionData,
  stopSocketConnection,
} from "../redux/auctions/auctions.actions";
import { resetCommonReducer } from "../redux/common/common.actions";
import triggerSleepClient from "./timeout-services";
import { store } from "../redux/store";
import { resetUserState } from "../redux/user/user.actions";
import router from "../components/History/index.component";
import secureLocalStorage from "react-secure-storage";

class GlobalLogout {
  private timeout: any;
  private timer: any;
  private refreshCallTimer: any;
  private instance: any;

  Initializer(timeout, timer, refreshCallTimer, instance) {
    this.timeout = timeout;
    this.timer = timer;
    this.refreshCallTimer = refreshCallTimer;
    this.instance = instance;
  }

  Logout = () => {
    clearTimeout(this.timeout.current);
    clearInterval(this.timer.current);
    clearInterval(this.refreshCallTimer.current);
    triggerSleepClient.stopTimers();
    if (this.instance.current) {
      this.instance.current?.destroy();
      this.instance.current = null;
    }
    store.getState().auction?.socket?.connected && store.dispatch(stopSocketConnection());
    store.dispatch(resetAuctionData());
    store.dispatch(resetCommonReducer());
    store.dispatch(resetUserState());
    secureLocalStorage.clear();
    return router.navigate("/signin", { replace: true });
  };
}

const GlobalLogoutClient = new GlobalLogout();
export default GlobalLogoutClient;
